export class KeyringLockedError extends Error {
  // This gives the error type safety
  private readonly typeName = 'KeyringLockedError'
  public readonly name = this.typeName

  constructor(message?: string) {
    super(message || 'Keyring is locked')
  }
}
